import axios from "axios";

import { encodeSearchTerm } from "@catchoftheday/utilities";

export const searchRedirectUrl = async (
  query: string
): Promise<string | null | undefined> => {
  try {
    const res = await axios.get(
      `/search/redirect-url?query=${encodeSearchTerm(query)}`
    );

    return res.data.redirectUrl;
  } catch (e) {
    return null;
  }
};
